import React, { Component } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import { connect } from 'react-redux';
import { initAssetTypes, initAssetSummary } from '@renenet/shared/src/actions/assets'
import { AssetGroups } from '@renenet/shared/src/constants/assetGroups'

import AssetSummaryEmptyPlaceholder from './AssetSummaryEmptyPlaceholder.js'
import AssetSummaryTable from './AssetSummaryTable.js'
import AssetTotalHighlight from './AssetTotalHighlight.js'
import AssetTypeSummaryPie from './AssetTypeSummaryPie.js'
import AssetTypeSummaryTable from './AssetTypeSummaryTable.js'
import AssetCreateContainer from './AssetCreateContainer.js'
import AssetGroupingSelector from './AssetGroupingSelector.js'


function mapStateToProps(state) {
  return {
    currencyInfo: state.currencyInfo,
    assetInfo: state.assetInfo
  }
}

function mapDispatchToProps(dispatch) {
  return {
    initAssetTypes: () => dispatch(initAssetTypes()),
    initAssetSummary: (currencyInfo) => dispatch(initAssetSummary(currencyInfo))
  }
}

class Asset extends Component {

  async componentDidMount() {
    await Promise.all([this.props.initAssetTypes(), this.props.initAssetSummary(this.props.currencyInfo)])
  }

  render() {
    const isIndividual = this.props.assetInfo.assetGroup === AssetGroups.INDIVIDUAL;
    const hasAssets = this.props.assetInfo.assetSummary && this.props.assetInfo.assetSummary.length > 0;
    return (
      <Container>
        <Row className="align-items-center">
          <Col><h2>Asset Aggregation</h2></Col>
          <Col xs="auto"><AssetGroupingSelector /></Col>
        </Row>
        <Row>
          <Col><AssetTotalHighlight /></Col>
        </Row>
        {hasAssets && (
          <Row>
            {!isIndividual && (
              <Col>
                <AssetTypeSummaryTable />
              </Col>
            )}
            <Col><AssetTypeSummaryPie /></Col>
          </Row>
        )}
        {!hasAssets && this.props.assetInfo.assetSummary !== null && (
          <Row><Col><AssetSummaryEmptyPlaceholder /></Col></Row>
        )}
        <Row>
          <Col><h2>Individual Assets</h2></Col>
          <Col />
          <Col>{this.props.assetInfo.assetTypes.length === 0 ? <Spinner animation="border" variant="primary" /> : <AssetCreateContainer />}</Col>
        </Row>
        <Row>
          <Col>
            {this.props.assetInfo.assetSummary === null
              ? <Spinner animation="border" variant="primary" />
              : (hasAssets ? <AssetSummaryTable /> : <AssetSummaryEmptyPlaceholder />)
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Asset);
